module.exports = __webpack_public_path__ + "static/media/CA.ea6532d7.svg";